var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HEC_Paris",
    "data-name": "HEC Paris",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.702,
    height: 69.233,
    viewBox: "0 0 256.702 69.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12667",
    "data-name": "Group 12667",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1156",
    "data-name": "Rectangle 1156",
    fill: "#fcfcfd",
    stroke: "#f4f5f6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256.702,
    height: 69.233,
    rx: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 255.702,
    height: 68.233,
    rx: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17132",
    "data-name": "Group 17132",
    transform: "translate(19.151 6.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flux_logo_blue_black",
    transform: "translate(50.236 9.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    d: "M18.024,0A17.9,17.9,0,1,1,0,17.9,17.9,17.9,0,0,1,18.024,0Z",
    transform: "translate(0 0)",
    fill: "#1b2430"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(8.162 6.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M69.663,127.846l-2.052,1.184-4.4-2.542,2-1.155.05-.029.077.044Z",
    transform: "translate(-57.694 -106.128)",
    fill: "#bdf328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M54.816,32.855v2.383l-4.335-2.5-1.176-.679-1.176.679-5.508,3.181-1.178.681V38l-2.12-1.224L38.148,36.1l-1.176.679-1.994,1.151V32.855L44.9,27.131Z",
    transform: "translate(-34.978 -27.131)",
    fill: "#bdf328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M91.132,69.431v6.362l-5.51,3.181-.008,0-5.5-3.177V69.431l5.51-3.183Z",
    transform: "translate(-71.295 -58.608)",
    fill: "#bdf328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M41.318,88.764v3.659l-3.17,1.831-3.17-1.831V88.764l3.17-1.829Z",
    transform: "translate(-34.978 -75.253)",
    fill: "#bdf328"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(43.937 6.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M211.583,38.682v6.137H222.8V49.13H211.583v8.463h-5.609V34.369h18.314v4.313Z",
    transform: "translate(-205.974 -34.369)",
    fill: "#1b2430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M295.931,34.369h5.4V57.593h-5.4Z",
    transform: "translate(-275.16 -34.369)",
    fill: "#1b2430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M357.479,57.575V76.2h-5.125V73.986a7.536,7.536,0,0,1-5.781,2.493c-4.674,0-7.963-2.631-7.963-8.378V57.575h5.4V67.3c0,3.116,1.383,4.5,3.773,4.5,2.493,0,4.292-1.592,4.292-5.022V57.575Z",
    transform: "translate(-308.335 -52.981)",
    fill: "#1b2430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M441.9,76.2l-4.085-5.715L433.6,76.2h-5.891l7.165-9.385-6.922-9.243h6.058l3.954,5.436,4.05-5.436h5.747l-6.926,9.1,7.194,9.523Z",
    transform: "translate(-377.173 -52.981)",
    fill: "#1b2430"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17131",
    "data-name": "Group 17131",
    transform: "translate(74.192 3.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79599",
    "data-name": "Path 79599",
    d: "M-1609.452,13207.568v1.488h18.741v-1.488Z",
    transform: "translate(1609.452 -13204.825)",
    fill: "#caff2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79598",
    "data-name": "Path 79598",
    d: "M4-2.118H.843V-7.41H2.035v4.326H4Zm.91,0L6.832-7.41H8.246l1.883,5.292h-1.3l-.358-1.1H6.552L6.2-2.118Zm1.9-2.034H8.194L7.611-5.988q-.033-.111-.054-.188a1.544,1.544,0,0,1-.035-.2h-.03q-.018.111-.039.192T7.4-6Zm4.523,2.034V-7.41H13.26a2.344,2.344,0,0,1,1.362.336,1.093,1.093,0,0,1,.476.949,1.158,1.158,0,0,1-.255.744,1.326,1.326,0,0,1-.648.445v.011a1.268,1.268,0,0,1,.81.4,1.188,1.188,0,0,1,.3.821,1.413,1.413,0,0,1-.519,1.156,2.178,2.178,0,0,1-1.421.427Zm1.192-4.415v1.292h.524a.88.88,0,0,0,.579-.177.6.6,0,0,0,.212-.486.54.54,0,0,0-.216-.471,1.117,1.117,0,0,0-.653-.157Zm0,2.178V-3h.648a.994.994,0,0,0,.648-.192.641.641,0,0,0,.234-.524.555.555,0,0,0-.231-.471,1.061,1.061,0,0,0-.644-.172Zm3.767,1.887.495-.927a3.035,3.035,0,0,0,.692.319,2.26,2.26,0,0,0,.618.083,1,1,0,0,0,.631-.162.546.546,0,0,0,.2-.449.534.534,0,0,0-.162-.419,1.4,1.4,0,0,0-.6-.246,2.822,2.822,0,0,1-1.288-.576,1.35,1.35,0,0,1-.4-1.041A1.484,1.484,0,0,1,17-7.032,2.1,2.1,0,0,1,18.459-7.5a3.341,3.341,0,0,1,.768.089,3.27,3.27,0,0,1,.716.259l-.447.941a2.551,2.551,0,0,0-.576-.245,1.907,1.907,0,0,0-.5-.074.957.957,0,0,0-.557.14.462.462,0,0,0-.2.4.425.425,0,0,0,.183.369,1.978,1.978,0,0,0,.655.237,2.518,2.518,0,0,1,1.242.583,1.486,1.486,0,0,1,.384,1.092A1.543,1.543,0,0,1,19.6-2.491a2.262,2.262,0,0,1-1.537.465,3.9,3.9,0,0,1-.918-.116,3.253,3.253,0,0,1-.85-.327Z",
    transform: "translate(20.065 7.507)",
    fill: "#caff2a",
    stroke: "#caff2a",
    strokeWidth: 0.376
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/Flux.8e6df4c7a2af27d3e4e42a2d1e22e604.svg";
export { ForwardRef as ReactComponent };